import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImageDataService {
  imageData = new Subject<string>();
  constructor() { }
}
